import { addMonths } from 'date-fns';

import { MAX_MFA_NUDGE_DISMISSALS, MFA_NUDGE_STATUS_KEY } from '../constants';

import { type MFANudgeState } from './getMfaNudgeStatus';

import { getLocalStorageItem, setLocalStorageItem } from '@/modules/storage';
import { safeJsonParse } from '@/modules/storage/helpers';

export function setMfaNudgeStatus() {
  const storedStatus = getLocalStorageItem(MFA_NUDGE_STATUS_KEY);
  const { dismissals = [] } =
    safeJsonParse<MFANudgeState>(storedStatus, null) || {};
  const now = new Date();
  const resetDismissals = dismissals.length >= MAX_MFA_NUDGE_DISMISSALS;
  const newState: MFANudgeState = {
    dismissals: resetDismissals
      ? [now.toISOString()]
      : [now.toISOString(), ...dismissals],
  };

  if (newState.dismissals.length >= MAX_MFA_NUDGE_DISMISSALS) {
    newState.snoozedUntil = addMonths(now, 3).toISOString();
  }

  setLocalStorageItem(MFA_NUDGE_STATUS_KEY, JSON.stringify(newState));
}
